import VueX from '@/store';

export default (to, from, next,) => {
  const redirect = to.name.indexOf('franchise',) < 0 ? '/franquias' : '/franquia';
  if (VueX.getters['user/user']?.businessType !== 'Franqueadora') {
    next(redirect,);
  } else {
    next();
  }
};
